/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

const zh_hans1_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新密码`)
};

const zh_hant1_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新密碼`)
};

const fr_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau mot de passe`)
};

const de_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Passwort`)
};

const ja_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいパスワード`)
};

const ko_settings_new_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 비밀번호`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_new_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_new_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_new_password", locale)
	if (locale === "en") return en_settings_new_password(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_new_password(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_new_password(inputs)
	if (locale === "fr") return fr_settings_new_password(inputs)
	if (locale === "de") return de_settings_new_password(inputs)
	if (locale === "ja") return ja_settings_new_password(inputs)
	return ko_settings_new_password(inputs)
};